import { defineMessages } from 'react-intl'

const scope = `procurify.expense.view.ApprovableTravelCards`

export default defineMessages({
  emptyStateHeader: {
    id: `${scope}.emptyStateHeader`,
    defaultMessage: 'You do not have any travel requests',
  },
  selectTravelAriaLabel: {
    id: `${scope}.selectTravelAriaLabel`,
    defaultMessage: 'Select travel {travelId}',
  },
})
